import React from 'react'
import classNames from 'classnames';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputAdornment from "@material-ui/core/InputAdornment";
import ReactTooltip from 'react-tooltip'
import { FaInfoCircle } from 'react-icons/fa';

import POLLUTANTS_CONFIG from '../../../config/FormComponents/Pollutants.json'

const Pollutants = props => (
    <div className="form-input-container">
        <div>
            <b>Pollutants </b><FaInfoCircle data-tip data-for="pollutant-info"/>

            <ReactTooltip id='pollutant-info' place="right" type="light" effect="solid">
                At least one pollutant must be checked. If using previous Stack Parameter File, check the corresponding pollutants.
            </ReactTooltip>
        </div>

        <FormGroup row key="pollutants" className={classNames(props.classes.margin, props.classes.textField)}>
            {POLLUTANTS_CONFIG.pollutants.map(option => (
                <FormControlLabel
                    key={option.value}
                    control={
                        <Checkbox
                            name={option.value}
                            checked={props[option.value]}
                            onChange={props.handleInputChange}
                            value={option.value}
                            color="primary"/>
                    }
                    label={option.label}/>
            ))}
        </FormGroup>
        {props.no2 ? showNO2Vars(props) : null}
    </div>
)

function showNO2Vars(props){
    return (

        <div>
            <div style={{paddingLeft: '20px'}}> Tier 3 ORM option used: </div>
            <FormControl className={classNames(props.classes.margin, props.classes.textField)}>
                <InputLabel shrink>In Stack Ratio</InputLabel>
                <Input
                    style={{width: "100px"}}
                    inputProps={{ min: "0.1", max: "0.9", step: "0.1" }}
                    type="number"
                    name="inStackRatio"
                    value={props.inStackRatio}
                    onChange={props.handleInputChange}/>
            </FormControl>

            <FormControl className={classNames(props.classes.margin, props.classes.textField)}>
                <InputLabel shrink>Background Ozone Value</InputLabel>

                <Input
                    style={{width: '194px'}}
                    data-tip data-for="backgroundOzoneValue"
                    inputProps={{ min: "0", max: "999", step: "0.1" }}
                    type="number"
                    name="backgroundOzoneValue"
                    value={props.backgroundOzoneValue}
                    onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">ppb</InputAdornment>}
                />
            </FormControl>
            <ReactTooltip id='backgroundOzoneValue' place="right" type="light" effect="solid">
                If left at 0, value will be calculated based on nearby monitor data.
            </ReactTooltip>
        </div>
    )
}

export default Pollutants;
